export const getMonetateExperience = (features, partialExperienceName) =>
  features?.monetateExperiences?.find(exp =>
    exp?.experienceName?.includes(partialExperienceName)
  );
